import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { setLoading } from '../../services/global/globalSlice'
import { fetchOfaSettings, fetchUpdateOfaSettings, fetchSubjects } from './SuperAdminApi'
import Form from 'react-bootstrap/Form'
import AddGroupInput from '../UsersScreen/_components/AddGroupInput'

export default function OfaSettingsManager(){
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [settings, setSettings] = useState({
        esse3_integration_enabled: false,
        esse3_base_url: '',
        extra_field_matricola_id: '',
        group_settings: []
    })
    const [subjects, setSubjects] = useState([])
    const [selectedSubjectByGroup, setSelectedSubjectByGroup] = useState({})

    const load = async () => {
        dispatch(setLoading(true))
        const [settingsRes, subjectsRes] = await Promise.all([
            fetchOfaSettings(),
            fetchSubjects()
        ])
        if(settingsRes.success){ setSettings(settingsRes.data || settings) }
        if(subjectsRes.success){ setSubjects(subjectsRes.data || []) }
        dispatch(setLoading(false))
    }

    const handleBaseChange = (key, value) => {
        setSettings({ ...settings, [key]: value })
    }

    const addGroupSetting = () => {
        setSettings({
            ...settings,
            group_settings: [
                ...settings?.group_settings || [],
                {
                    group_id: '',
                    esse3_test_id: '',
                    esse3_aa_id: '',
                    subjects: [],
                    video_completion_group_id: '',
                    retry_exam_group_id: ''
                }
            ]
        })
    }

    const updateGroupField = (index, key, value) => {
        const next = [...settings.group_settings]
        next[index] = { ...next[index], [key]: value }
        setSettings({ ...settings, group_settings: next })
    }

    const handleSelectSubjectForGroup = (index, subject_id) => {
        setSelectedSubjectByGroup({ ...selectedSubjectByGroup, [index]: subject_id })
    }

    const addGroupSubject = (index) => {
        const pickedId = selectedSubjectByGroup[index]
        if(!pickedId) return
        const subject = subjects.find(s => `${s.subject_id}` === `${pickedId}`)
        if(!subject) return
        const next = [...settings.group_settings]
        const existing = next[index]?.subjects || []
        if(existing.some(s => `${s.subject_id}` === `${subject.subject_id}`)) return
        next[index] = { ...next[index], subjects: [ ...existing, { subject_id: subject.subject_id, subject_name: subject.subject_name } ] }
        setSettings({ ...settings, group_settings: next })
    }

    const updateGroupSubject = (groupIndex, subjectIndex, key, value) => {
        const next = [...settings.group_settings]
        const subs = [...(next[groupIndex]?.subjects || [])]
        subs[subjectIndex] = { ...subs[subjectIndex], [key]: value }
        next[groupIndex] = { ...next[groupIndex], subjects: subs }
        setSettings({ ...settings, group_settings: next })
    }

    const removeGroupSubject = (groupIndex, subjectIndex) => {
        const next = [...settings.group_settings]
        const subs = [...(next[groupIndex]?.subjects || [])]
        subs.splice(subjectIndex,1)
        next[groupIndex] = { ...next[groupIndex], subjects: subs }
        setSettings({ ...settings, group_settings: next })
    }

    const removeGroupSetting = (index) => {
        const next = settings.group_settings.filter((_,i)=>i!==index)
        setSettings({ ...settings, group_settings: next })
    }

    const handleSave = async () => {
        dispatch(setLoading(true))
        const res = await fetchUpdateOfaSettings(settings)
        dispatch(setLoading(false))
        return res
    }

    useEffect(()=>{ load() }, [])

    return (
        <section>
            <div className="d-flex flex-wrap">
                <Form.Check
                    type="switch"
                    id="esse3_integration_enabled"
                    label={'Integrazione Esse3 attiva'}
                    checked={!!settings.esse3_integration_enabled}
                    onChange={(e)=>handleBaseChange('esse3_integration_enabled', e.target.checked)}
                    className="me-3"
                />
                <Form.Group className="me-3" controlId="esse3_base_url">
                    <Form.Label>Esse3 Base URL</Form.Label>
                    <Form.Control type="text" value={settings.esse3_base_url || ''} onChange={(e)=>handleBaseChange('esse3_base_url', e.target.value)} />
                </Form.Group>
                <Form.Group className="me-3" controlId="extra_field_matricola_id">
                    <Form.Label>Campo extra Matricola ID</Form.Label>
                    <Form.Control type="text" value={settings.extra_field_matricola_id || ''} onChange={(e)=>handleBaseChange('extra_field_matricola_id', e.target.value)} />
                </Form.Group>
            </div>

            <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5>Configurazioni gruppi</h5>
                    <button onClick={addGroupSetting}>{t?.groups?.add_group || 'Aggiungi gruppo'}</button>
                </div>
                {settings.group_settings?.length ? settings.group_settings.map((g, idx)=> (
                    <div key={idx} className="border rounded p-3 mb-3">
                        <div className="d-flex flex-wrap align-items-end">
                            <Form.Group className="me-3 mb-2" controlId={`group_${idx}`}>
                                <Form.Label>Group ID</Form.Label>
                                <div className="d-flex align-items-center">
                                    <Form.Control type="text" value={g.group_id || ''} onChange={(e)=>updateGroupField(idx,'group_id', e.target.value)} />
                                    <div className="ms-2">
                                        <AddGroupInput label={'Seleziona gruppo'} onAddGroup={(grp)=>updateGroupField(idx,'group_id', grp?.group_id)} />
                                    </div>
                                </div>
                            </Form.Group>
                            <Form.Group className="me-3 mb-2" controlId={`test_${idx}`}>
                                <Form.Label>Esse3 Test ID</Form.Label>
                                <Form.Control type="text" value={g.esse3_test_id || ''} onChange={(e)=>updateGroupField(idx,'esse3_test_id', e.target.value)} />
                            </Form.Group>
                            <Form.Group className="me-3 mb-2" controlId={`aa_${idx}`}>
                                <Form.Label>Esse3 AA ID</Form.Label>
                                <Form.Control type="text" value={g.esse3_aa_id || ''} onChange={(e)=>updateGroupField(idx,'esse3_aa_id', e.target.value)} />
                            </Form.Group>
                            <Form.Group className="me-3 mb-2" controlId={`video_group_${idx}`}>
                                <Form.Label>Video completion group ID</Form.Label>
                                <div className="d-flex align-items-center">
                                    <Form.Control type="text" value={g.video_completion_group_id || ''} onChange={(e)=>updateGroupField(idx,'video_completion_group_id', e.target.value)} />
                                    <div className="ms-2">
                                        <AddGroupInput label={'Seleziona gruppo'} onAddGroup={(grp)=>updateGroupField(idx,'video_completion_group_id', grp?.group_id)} />
                                    </div>
                                </div>
                            </Form.Group>
                            <Form.Group className="me-3 mb-2" controlId={`retry_group_${idx}`}>
                                <Form.Label>Retry exam group ID</Form.Label>
                                <div className="d-flex align-items-center">
                                    <Form.Control type="text" value={g.retry_exam_group_id || ''} onChange={(e)=>updateGroupField(idx,'retry_exam_group_id', e.target.value)} />
                                    <div className="ms-2">
                                        <AddGroupInput label={'Seleziona gruppo'} onAddGroup={(grp)=>updateGroupField(idx,'retry_exam_group_id', grp?.group_id)} />
                                    </div>
                                </div>
                            </Form.Group>
                            <div className="ms-auto mb-2">
                                <button onClick={()=>removeGroupSetting(idx)}>{t?.actions?.delete || 'Elimina'}</button>
                            </div>
                        </div>

                        <div className="mt-2">
                            <div className="d-flex justify-content-between align-items-center">
                                <h6>Materie</h6>
                                <div className="d-flex align-items-end">
                                    <Form.Group className="me-2" controlId={`select_subject_${idx}`}>
                                        <Form.Label>Seleziona materia</Form.Label>
                                        <Form.Select value={selectedSubjectByGroup[idx] || ''} onChange={(e)=>handleSelectSubjectForGroup(idx, e.target.value)}>
                                            <option value="">Scegli...</option>
                                            {subjects?.map(s => (
                                                <option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <button onClick={()=>addGroupSubject(idx)}>{'Aggiungi'}</button>
                                </div>
                            </div>
                            {g.subjects?.length ? g.subjects.map((s, sIdx)=>(
                                <div key={sIdx} className="d-flex align-items-center mt-2">
                                    <div className="me-3">{s.subject_name} <small className="text-muted">({s.subject_id})</small></div>
                                    <button onClick={()=>removeGroupSubject(idx, sIdx)}>{t?.actions?.delete || 'Elimina'}</button>
                                </div>
                            )) : null}
                        </div>
                    </div>
                )) : null}
            </div>

            <div className="d-flex justify-content-end">
                <button onClick={handleSave}>{t?.buttons?.edit_save || 'Salva modifiche'}</button>
            </div>
        </section>
    )
}



